/**
 * Builds a copy of `comment` moved to `newPosition`. Callout end/knee points are
 * left untouched on purpose: the arrow starts at the comment and points at a
 * fixed target, so moving the comment only re-anchors the arrow's start while
 * preserving where it points (users typically move the comment, not the thing it
 * references).
 */
export const moveComment = (comment: Comment3D, newPosition: Point): Comment3D => {
  return { ...comment, position: newPosition }
}
